import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-sub-menu2',
  templateUrl: './sub-menu2.component.html',
  styleUrls: ['./sub-menu2.component.sass'],
})
export class SubMenu2Component implements OnInit {
  @Input('menu') menu: any;

  constructor() {}

  ngOnInit(): void {}
}
